"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComparisonProductSelectorItem = _interopRequireDefault(require("./ComparisonProductSelectorItem"));
var _r10SourceLibrary = require("r10-source-library");
var _useComparison = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _config = _interopRequireDefault(require("../../config/config"));
var _config$uiSettings;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const background = _config.default !== null && _config.default !== void 0 && (_config$uiSettings = _config.default.uiSettings) !== null && _config$uiSettings !== void 0 && _config$uiSettings.showComparisonGrayBg ? _BaseComponents.GrayBackground : _BaseComponents.LightBackground;
const ProductSelectorWrapper = (0, _styledComponents.default)(background('div'))`
  padding-bottom: 64px;
`;
const ComparisonProductSelector = _ref => {
  let {
    displayedProducts
  } = _ref;
  //Here I want the products to be displayed which can be created from the comparableProducts and the displayedProducts
  const {
    products,
    updateCurrentSelectedProducts,
    onProductSelect,
    notSelectedProducts
  } = (0, _useComparison.default)();
  const showAllProducts = displayedProducts.length >= 3;
  const selectOptionFactory = productId => {
    return [products[productId], ...notSelectedProducts].map(product => {
      return {
        text: product.productName,
        value: product.productId
      };
    });
  };
  return /*#__PURE__*/_react.default.createElement(ProductSelectorWrapper, {
    id: "comparison-product-selector"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true
  }, displayedProducts.map((productId, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: productId
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, showAllProducts ? {
      col: 4
    } : {}, /*#__PURE__*/_react.default.createElement(_ComparisonProductSelectorItem.default, {
      selectedProduct: products[productId],
      setSelectedProduct: updateCurrentSelectedProducts,
      onSelect: onProductSelect,
      selectOptions: selectOptionFactory(productId),
      index: index
    })));
  })));
};
var _default = ComparisonProductSelector;
exports.default = _default;